/**
 * IM 重连用的 access token 刷新（story AC-3）。
 * 走裸 axios（不经 apiClient 拦截器）：刷新请求**不带 Authorization**，
 * 且失败不触发拦截器的 401 自动跳登录 —— 由连接引擎按 CLOSED(TOKEN_EXPIRED) 处理。
 */
import axios from 'axios';
import { useAuthStore } from '@/store/auth';
import type { components } from '@/api/openapi.generated';

type TokenPairResponse = components['schemas']['TokenPairResponse'];
interface Envelope<T> {
  code: string;
  message: string;
  data: T;
}

const BASE_URL = import.meta.env.VITE_API_BASE ?? '';

/** 刷新成功 → 写回会话 store 并返回新 accessToken；失败返回 null。 */
export async function refreshImToken(): Promise<string | null> {
  const { refreshToken, userId, identityState } = useAuthStore.getState();
  if (!refreshToken) return null;
  try {
    const resp = await axios.post<Envelope<TokenPairResponse>>(
      '/api/v1/auth/refresh',
      { refreshToken },
      { baseURL: BASE_URL, timeout: 15_000 },
    );
    const env = resp.data;
    if (!env || env.code !== '000000' || !env.data?.accessToken) return null;
    const t = env.data;
    useAuthStore.getState().setSession({
      accessToken: t.accessToken!,
      refreshToken: t.refreshToken ?? refreshToken,
      accessTokenExpiresAt:
        typeof t.accessTokenExpiresIn === 'number'
          ? Date.now() + t.accessTokenExpiresIn * 1000
          : Date.now() + 3600 * 1000,
      userId: t.userId ?? userId ?? '',
      identityState: t.identityState ?? identityState ?? null,
    });
    return t.accessToken!;
  } catch {
    return null;
  }
}
